require('./loanPartialAmortizationStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const moment = require('moment');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { getLastNChars } = require('utilities/stringHelper');
const download = require('downloadjs');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { buildFormattedDate } = require('utilities/dateHelper');
const Immutable = require('immutable');
// @constants
const { EURO_TEXT, DATE_FORMAT_ES } = require('constants/index');
const { LOAN_PARTIAL_AMORTIZATION_CONFIRMATION } = require('constants/operationTypes');
const {

    ADVANCE_END_DATE,
    INE_DOCUMENT_NAME,

} = require('../../../../loansConstants/index').amortizationTypes;


// @ components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const LoanCollectiveTag = require('../../loanCollectiveTag/loanCollectiveTag');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class LoanPartialAmortizationStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPdfLoaded: false,
        };
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);

    }

    buildCommissionData() {
        const { immPartialAmortization, newLoanPartialFF } = this.props;
        const amortizationData = immPartialAmortization.get('partialAmortizationSimulationData');
        const amortizationDetails = immPartialAmortization.get('partialAmortizationDetails');
        const amortizationDetailsInmutable = Immutable.fromJS(amortizationDetails)
        const amountFinancialLoss = amortizationDetailsInmutable.getIn(['perdidaFinanciera', 'importe']);
        const commissionData = {
            commission: {
                currency: amortizationData.get('commission')
            },
            newFee: {
                currency: amortizationData.get('newFee')
            },
            percentage: amortizationData.get('percentage')
        };
        const financialLoss = {
            currency: amountFinancialLoss
        };

        const tooltipContent = formatText('loanPartialAmortization-commissionToolTipContent', [commissionData.percentage]);
        const tooltipComponent = (
            <OKTooltip
                content={tooltipContent}
                offset={[0, -15]}
                title="loanPartialAmortization-commissionToolTipTitle"
                type="explicative"
            />
        );
        const tooltipFinancialLostContent = formatText('loanPartialAmortization-financialLostToolTipContent');

        const tooltipFinalcialLost = (
            <OKTooltip
                content={tooltipFinancialLostContent}
                offset={[0, -15]}
                type="explicative"
            />
        );
        return (
            <>
                {!newLoanPartialFF ?
                    <div className="loan-amortization-confirmation-step__result-row" >
                        <span className="loan-amortization-confirmation-step__data-title" >
                            {formatText('loanPartialAmortization-commission')}
                            {tooltipComponent}
                        </span>
                        <span className="loan-amortization-confirmation-step__data-value">{MortgageRequestCurrencyHelp(commissionData.commission)}</span>
                    </div>
                    :
                    <>
                        <div className="loan-amortization-confirmation-step__result-row" >
                            <span className="loan-amortization-confirmation-step__data-title" >
                                {formatText('loanPartialAmortization-commission')}*
                            </span>
                            <span className="loan-amortization-confirmation-step__data-value">{MortgageRequestCurrencyHelp(commissionData.commission)}</span>
                        </div>
                        <div className="loan-amortization-confirmation-step__result-row" >
                            <span className="loan-amortization-confirmation-step__data-title" >
                                {formatText('loanPartialAmortization-financialLoss')}
                                **
                                {tooltipFinalcialLost}
                            </span>
                            <span className="loan-amortization-confirmation-step__data-value">{MortgageRequestCurrencyHelp(financialLoss)}</span>
                        </div>
                    </>
                }
            </>
        );
    }

    buildBadge() {
        const { immLoan } = this.props;

        return (
            <LoanCollectiveTag
                extraClass="loan-amortization-confirmation-step__collective-tag"
                immLoan={immLoan}
            />
        );
    }
    handleOnDownloadDocument() {
        const { immPartialAmortization, downloadOrPrintDocument } = this.props;
        let documentName = '';
        let document;
        document = immPartialAmortization.get('loanPartialAmortizationDocument');
        documentName = INE_DOCUMENT_NAME;
        download(document, documentName, 'application/pdf');
        isPrintOfficeMode() && downloadOrPrintDocument()

    }

    handleOnPrintDocument() {
        const { immPartialAmortization, downloadOrPrintDocument } = this.props;
        const document = immPartialAmortization.get('loanPartialAmortizationDocument');
        if (document) {
            openBase64pdfInPrintWindow(document);
            isPrintOfficeMode() && downloadOrPrintDocument()
        }
    }
    handleDocumentReaded() {
        const { checkReadDocument } = this.props;
        checkReadDocument();
        this.setState({ isPdfLoaded: true });
    }
    buildPdfDocument() {
        const { immPartialAmortization } = this.props;
        const loanPartialAmortizationDocument = immPartialAmortization.get('loanPartialAmortizationDocument');

        return (
            <div className="retail-loan-step-three">
                <div className="retail-loan-step-three__title">
                    <FormattedText value="loanPartialAmortization-loanPartialAmortizationTitle" />
                </div>
                <div className="retail-loan-step-three__subtitle">
                    <FormattedText value="loanPartialAmortization-loanPartialAmortizationSubtitle" />
                </div>
                <div className="row">
                    <OKPdfViewer
                        title={formatText('loanPartialAmortization-pdfDcoumentTitle')}
                        onDownload={this.handleOnDownloadDocument}
                        onPrint={this.handleOnPrintDocument}
                        pdfFile={loanPartialAmortizationDocument}
                        displayScrollButton
                        scale={1}
                        viewerHeight={800}
                        infiniteScroll={false}
                        onDocumentReaded={this.handleDocumentReaded}
                    />
                </div>
            </div>

        );
    }
    buildPdfDocumentOffice() {
        const { immPartialAmortization } = this.props;
        const loanPartialAmortizationDocument = immPartialAmortization.get('loanPartialAmortizationDocument');

        return (
            <div className="retail-loan-step-three">
                <div className="retail-loan-step-three__title">
                    <FormattedText value="loanPartialAmortization-loanPartialAmortizationTitle" />
                </div>
                <div className="retail-loan-step-three__subtitle">
                    <FormattedText value="loanPartialAmortization-loanPartialAmortizationSubtitle" />
                </div>
                <BlockInfo>
                    <FormattedText value={"contractEasyLoanStepFour-contractBlockTitle"} className="contract-easy-loan-step-four informative-title" /><br />
                    <FormattedText value={"contractEasyLoanStepFour-contractBlockSubTitle"} />
                </BlockInfo>
                <br />
                <br />
                <div className="row">
                    <OKPdfViewer
                        title={formatText('loanPartialAmortization-pdfDcoumentTitle')}
                        onDownload={this.handleOnDownloadDocument}
                        onPrint={this.handleOnPrintDocument}
                        pdfFile={loanPartialAmortizationDocument}
                        displayScrollButton
                        scale={1}
                        viewerHeight={800}
                        infiniteScroll={false}
                        onDocumentReaded={this.handleDocumentReaded}
                    />
                </div>
            </div>

        );
    }
    blockInfoOffice() {
        return (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check hire-card-open-credit-step-five__block-info-officine" hasCheckbox>
                <strong><FormattedText value="hireCardOpenCreditStep5-blockInfoOficineTitle" /></strong>
                <br />
                <br />
                <FormattedText value="hireCardOpenCreditStep5-blockInfoOficineSubTitle" />
            </BlockInfo>
        );
    }
    blockInfoCC() {
        const { immProfile } = this.props;
        const name = " " + immProfile.get("nombreCompleto");
        return (
            <div className="contract-easy-loan-typec-document-step__blockView">
                <div className="contract-easy-loan-typec-document-step__subtitle">
                    <FormattedText value="contractEasyLoanTypeCStepTwo-blockHeadingTitle" />
                </div>
                <BlockInfo>
                    <FormattedText value={'contractEasyLoanTypeCStepTwo-blockCCTitleStart'} />
                    {name}
                    <br />
                    <FormattedText value={'loanPartialAmortization-blockCCTitle'} />
                </BlockInfo>
            </div>
        );
    }

    buildQuestion(text) {
        const { immProfile } = this.props;
        const name = PersonalDataHelper.getFullName(immProfile, false);
        const keyName = `<b>${name}</b>`;

        return (
            <>
                <FormattedText value={text} injectedStrings={[keyName]} />
                <br />
            </>
        )

    }

    render() {
        const { immPartialAmortization, newLoanPartialFF } = this.props;
        const { isPdfLoaded } = this.state;
        const amortizationData = immPartialAmortization.get('partialAmortizationData');
        const operationProcessId = immPartialAmortization.get('operationProcessIdInit');
        const downloadOrPrintDocument = immPartialAmortization.get('downloadOrPrintDocument');
        const formattedAssociatedAccount = `${immPartialAmortization.get('description')} ${getLastNChars(immPartialAmortization.get('accountNumber'))}`;
        const amortizationStepsData = immPartialAmortization.get('partialAmortizationSimulationData');
        const amortizationType = amortizationStepsData.get('amortizationType');
        const newAmountValue = amortizationStepsData.get('amount');
        const newDate = amortizationStepsData.get('newDate');
        const formattedNewDate = DateHelper.buildFormattedDate(newDate, 'DD MMM YYYY');
        const badge = this.buildBadge();
        const buildPdf = this.buildPdfDocument();
        const buildPdfOffice = this.buildPdfDocumentOffice();
        const blockInfoCC = newLoanPartialFF && __CONTACT_CENTER__ && !isPrintOfficeMode() && this.blockInfoCC();
        const confirmationQuestion = newLoanPartialFF && __CONTACT_CENTER__ && !isPrintOfficeMode() && this.buildQuestion('confirmationScript-promptMsg')

        const currencyBalanceParams = {
            currency: Math.abs(immPartialAmortization.get('balance'))
        };
        const currencyInitialCapitalParams = {
            currency: amortizationData.getIn(['initLimitAmount', 'amount'])
        };
        const currencyPendingCapitalParams = {
            currency: amortizationData.getIn(['currentLimitAmount', 'amount'])
        };
        const currencyQuotaParams = {
            currency: immPartialAmortization.get('receiptTotal')
        };
        const currencyNewFee = {
            currency: amortizationStepsData.get('newFee')
        };
        const currencyNewAmount = {
            currency: newAmountValue
        };

        const codbban = amortizationData.getIn(['intAssociatedAccount', 'codbban']).trim();
        const country = amortizationData.getIn(['intAssociatedAccount', 'country']);
        const controlDigit = amortizationData.getIn(['intAssociatedAccount', 'controlDigit']);
        const originAccount = `${country}${controlDigit}${codbban}`;
        const operationParams = {
            ammount: newAmountValue,
            currency: EURO_TEXT,
            originAccount,
            ...(newLoanPartialFF && {
                operationProcessId,
                evidenceType: 'SIGN_DOCUMENT'
            })
        };

        const simulationParamValue = amortizationType === ADVANCE_END_DATE ? formattedNewDate : MortgageRequestCurrencyHelp(currencyNewFee);
        const simulationParamLabel = amortizationType === ADVANCE_END_DATE ? formatText('loanPartialAmortization-newDateValue') : formatText('loanPartialAmortization-newFeeValue');
        const valueDate = amortizationStepsData.get('valueDate')
        const formattedValueDate = buildFormattedDate(valueDate, DATE_FORMAT_ES);

        return (
            <>
                {newLoanPartialFF ?
                    <>
                        {!__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                            <div className="loan-amortization-confirmation-step">
                                <h3 className="loan-amortization-confirmation-step__confirmation-title ">
                                    {formatText('loanPartialAmortization-subtitleConfirmation')}
                                </h3>
                                {blockInfoCC}
                                {badge}
                                <div className="loan-amortization-confirmation-step__data-container">
                                    <OKInformativeList columns={2}>
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-asociatedAccount')}
                                            bodyText={formattedAssociatedAccount}
                                        />

                                        <OKInformativeListItem
                                            className="loan-amortization-confirmation-step__balance"
                                            title={formatText('loanPartialAmortization-balance')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyBalanceParams)}>
                                        </OKInformativeListItem>
                                    </OKInformativeList>
                                </div>

                                <div className="loan-amortization-confirmation-step__data-container-top">
                                    <OKInformativeList columns={2}>
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-initialCapital')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyInitialCapitalParams)}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-dueDate')}
                                            bodyText={amortizationData.get('dueDate')}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-pendingCapital')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyPendingCapitalParams)}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-currentQuota')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyQuotaParams)}
                                        />
                                    </OKInformativeList>
                                </div>

                                <div className="row loan-amortization-confirmation-step__data-container-top">
                                    <div className="col-xs-6">
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {formatText('loanPartialAmortization-amortizedAmountLabel')}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {MortgageRequestCurrencyHelp(currencyNewAmount)}
                                            </span>
                                        </div>
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {simulationParamLabel}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {simulationParamValue}
                                            </span>
                                        </div>
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {formatText('loanPartialAmortization-valueDateLabel')}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {formattedValueDate}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6">
                                        {this.buildCommissionData()}
                                    </div>
                                </div>


                                {buildPdf}

                                <div className="row loan-amortization-confirmation-step__data-container-top-last">
                                    <div className="col-xs-12 loan-amortization-confirmation-step__signature-pattern-container">
                                        {confirmationQuestion}
                                        <SignaturePattern
                                            operationType={LOAN_PARTIAL_AMORTIZATION_CONFIRMATION}
                                            operationParams={operationParams}
                                            isOverDraft={newLoanPartialFF ? true : false}
                                            newOperationProcessId={operationProcessId}
                                        />

                                    </div>
                                </div>
                            </div>
                        }
                        {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                            <div className="loan-amortization-confirmation-step">
                                <h3 className="loan-amortization-confirmation-step__confirmation-title ">
                                    {formatText('loanPartialAmortization-subtitleConfirmation')}
                                </h3>
                                {blockInfoCC}
                                {badge}
                                <div className="loan-amortization-confirmation-step__data-container">
                                    <OKInformativeList columns={2}>
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-asociatedAccount')}
                                            bodyText={formattedAssociatedAccount}
                                        />

                                        <OKInformativeListItem
                                            className="loan-amortization-confirmation-step__balance"
                                            title={formatText('loanPartialAmortization-balance')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyBalanceParams)}>
                                        </OKInformativeListItem>
                                    </OKInformativeList>
                                </div>

                                <div className="loan-amortization-confirmation-step__data-container-top">
                                    <OKInformativeList columns={2}>
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-initialCapital')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyInitialCapitalParams)}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-dueDate')}
                                            bodyText={amortizationData.get('dueDate')}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-pendingCapital')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyPendingCapitalParams)}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-currentQuota')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyQuotaParams)}
                                        />
                                    </OKInformativeList>
                                </div>

                                <div className="row loan-amortization-confirmation-step__data-container-top">
                                    <div className="col-xs-6">
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {formatText('loanPartialAmortization-amortizedAmountLabel')}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {MortgageRequestCurrencyHelp(currencyNewAmount)}
                                            </span>
                                        </div>
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {simulationParamLabel}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {simulationParamValue}
                                            </span>
                                        </div>
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {formatText('loanPartialAmortization-valueDateLabel')}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {formattedValueDate}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6">
                                        {this.buildCommissionData()}
                                    </div>
                                </div>



                                <div className="row loan-amortization-confirmation-step__data-container-top-last">
                                    <div className="col-xs-12 loan-amortization-confirmation-step__signature-pattern-container">
                                        {confirmationQuestion}
                                        {operationProcessId && (
                                            <SignaturePattern
                                                operationType={LOAN_PARTIAL_AMORTIZATION_CONFIRMATION}
                                                operationParams={operationParams}
                                                isOverDraft={newLoanPartialFF ? true : false}
                                                newOperationProcessId={operationProcessId}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        }
                        {__CONTACT_CENTER__ && isPrintOfficeMode() &&
                            <div className="loan-amortization-confirmation-step">
                                <h3 className="loan-amortization-confirmation-step__confirmation-title ">
                                    {formatText('loanPartialAmortization-subtitleConfirmation')}
                                </h3>
                                {blockInfoCC}
                                {badge}
                                <div className="loan-amortization-confirmation-step__data-container">
                                    <OKInformativeList columns={2}>
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-asociatedAccount')}
                                            bodyText={formattedAssociatedAccount}
                                        />

                                        <OKInformativeListItem
                                            className="loan-amortization-confirmation-step__balance"
                                            title={formatText('loanPartialAmortization-balance')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyBalanceParams)}>
                                        </OKInformativeListItem>
                                    </OKInformativeList>
                                </div>

                                <div className="loan-amortization-confirmation-step__data-container-top">
                                    <OKInformativeList columns={2}>
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-initialCapital')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyInitialCapitalParams)}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-dueDate')}
                                            bodyText={amortizationData.get('dueDate')}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-pendingCapital')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyPendingCapitalParams)}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('loanPartialAmortization-currentQuota')}
                                            bodyText={MortgageRequestCurrencyHelp(currencyQuotaParams)}
                                        />

                                    </OKInformativeList>
                                </div>

                                <div className="row loan-amortization-confirmation-step__data-container-top">
                                    <div className="col-xs-6">
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {formatText('loanPartialAmortization-amortizedAmountLabel')}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {MortgageRequestCurrencyHelp(currencyNewAmount)}
                                            </span>
                                        </div>
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {simulationParamLabel}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {simulationParamValue}
                                            </span>
                                        </div>
                                        <div className="loan-amortization-confirmation-step__result-row">
                                            <span className="loan-amortization-confirmation-step__data-title">
                                                {formatText('loanPartialAmortization-valueDateLabel')}
                                            </span>
                                            <span className="loan-amortization-confirmation-step__data-value">
                                                {formattedValueDate}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-xs-6">
                                        {this.buildCommissionData()}
                                    </div>
                                </div>



                                {buildPdfOffice}

                                <div className="row loan-amortization-confirmation-step__data-container-top-last">
                                    <div className="col-xs-12 loan-amortization-confirmation-step__signature-pattern-container">
                                        {confirmationQuestion}
                                        {downloadOrPrintDocument && operationProcessId &&
                                            <SignaturePattern
                                                operationType={LOAN_PARTIAL_AMORTIZATION_CONFIRMATION}
                                                operationParams={operationParams}
                                                isEasyLoanTypeAB={isPrintOfficeMode() && true}
                                                newOperationProcessId={operationProcessId}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                    </>
                    :
                    <>
                        <div className="loan-amortization-confirmation-step">
                            <h3 className="loan-amortization-confirmation-step__confirmation-title ">
                                {formatText('loanPartialAmortization-subtitleConfirmation')}
                            </h3>
                            {badge}
                            <div className="loan-amortization-confirmation-step__data-container">
                                <OKInformativeList columns={2}>
                                    <OKInformativeListItem
                                        title={formatText('loanPartialAmortization-asociatedAccount')}
                                        bodyText={formattedAssociatedAccount}
                                    />

                                    <OKInformativeListItem
                                        className="loan-amortization-confirmation-step__balance"
                                        title={formatText('loanPartialAmortization-balance')}
                                        bodyText={MortgageRequestCurrencyHelp(currencyBalanceParams)}>
                                    </OKInformativeListItem>
                                </OKInformativeList>
                            </div>

                            <div className="loan-amortization-confirmation-step__data-container-top">
                                <OKInformativeList columns={2}>
                                    <OKInformativeListItem
                                        title={formatText('loanPartialAmortization-initialCapital')}
                                        bodyText={MortgageRequestCurrencyHelp(currencyInitialCapitalParams)}
                                    />
                                    <OKInformativeListItem
                                        title={formatText('loanPartialAmortization-dueDate')}
                                        bodyText={amortizationData.get('dueDate')}
                                    />
                                    <OKInformativeListItem
                                        title={formatText('loanPartialAmortization-pendingCapital')}
                                        bodyText={MortgageRequestCurrencyHelp(currencyPendingCapitalParams)}
                                    />
                                    <OKInformativeListItem
                                        title={formatText('loanPartialAmortization-currentQuota')}
                                        bodyText={MortgageRequestCurrencyHelp(currencyQuotaParams)}
                                    />
                                </OKInformativeList>
                            </div>

                            <div className="row loan-amortization-confirmation-step__data-container-top">
                                <div className="col-xs-6">
                                    <div className="loan-amortization-confirmation-step__result-row">
                                        <span className="loan-amortization-confirmation-step__data-title">
                                            {formatText('loanPartialAmortization-amortizedAmountLabel')}
                                        </span>
                                        <span className="loan-amortization-confirmation-step__data-value">
                                            {MortgageRequestCurrencyHelp(currencyNewAmount)}
                                        </span>
                                    </div>
                                </div>

                                <div className="col-xs-6">
                                    {this.buildCommissionData()}
                                </div>
                            </div>

                            <OKInformativeList columns={2}>
                                <OKInformativeListItem
                                    title={simulationParamLabel}
                                    bodyText={simulationParamValue}
                                />
                                <OKInformativeListItem
                                    title={formatText('loanPartialAmortization-valueDate')}
                                    bodyText={amortizationData.get('valueDate')}
                                />
                            </OKInformativeList>

                            <div className="row loan-amortization-confirmation-step__data-container-top-last">
                                <div className="col-xs-12 loan-amortization-confirmation-step__signature-pattern-container">
                                    <SignaturePattern
                                        operationType={LOAN_PARTIAL_AMORTIZATION_CONFIRMATION}
                                        operationParams={operationParams}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>

        )
    }
}

LoanPartialAmortizationStep2.propTypes = {
    immLoan: PropTypes.object.isRequired,
    immPartialAmortization: PropTypes.object.isRequired
};

module.exports = LoanPartialAmortizationStep2
